import VimeoPlayer, { vimeoUriToId } from './VimeoPlayer';

export default VimeoPlayer;
export { vimeoUriToId };